'use client';

const variantToLabelMap = {
  default: "Notification",
  success: "Status",
  upsell: "Offer",
  warning: "Warning",
  danger: "Error"
};
const dismissLabel = (label) => `Dismiss ${label}`;
const focusMockLabel = "Placeholder for removed element";
export {
  dismissLabel,
  focusMockLabel,
  variantToLabelMap
};
